import * as React from 'react';
import dayjs from 'dayjs';

export interface ConverterComponentProps {
  value?: any;
  onChange?: (value?: any) => void;
  encode: (value: any) => any; // Convert editor value to json object value
  decode: (value: any) => any; // Convert json object value editor value
  component: React.ComponentType<any>;
  disabledDate?: boolean;
  future?: boolean;
}

export default class ConverterComponent extends React.Component<ConverterComponentProps> {
  handleChange = (event: any) => {
    if (this.props.onChange === undefined || event === null) {
      return;
    }
    if (event.target !== undefined) {
      this.props.onChange(this.props.encode(event.target.value));
    } else {
      this.props.onChange(this.props.encode(event));
    }
  };
  disabledDate = (current: any) => {
    const { future, disabledDate } = this.props;
    if (disabledDate && !future) {
      return current && current > dayjs().endOf('day');
    }
    if (disabledDate && future) {
      return current && current < dayjs().endOf('day');
    }
    return current && current > dayjs().endOf('day');
  };

  render(): React.ReactNode {
    const COMP = this.props.component;
    return (
      <COMP
        {...this.props}
        value={this.props.value === undefined ? undefined : this.props.decode(this.props.value)}
        onChange={(event1: any) => this.handleChange(event1)}
        disabledDate={this.props.disabledDate ? this.disabledDate : undefined}
      />
    );
  }
}
